/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum AGGREGATION_VALUES {
  MAX = "max",
  MIN = "min",
  SUM = "sum",
  AVG = "avg",
  COUNT = "count",
  COUNT_DISTINCT = "countDistinct",
  COUNT_DISTINCT_APPROX = "countDistinctApprox",
}
